const audioToggles = document.querySelectorAll('[data-audio-player-toggle]');

audioToggles.forEach((toggle) => {
  const panelId = toggle.getAttribute('aria-controls');
  const panel = panelId ? document.getElementById(panelId) : document.querySelector('[data-audio-player-panel]');

  if (!panel) {
    toggle.hidden = true;
    return;
  }

  toggle.addEventListener('click', () => {
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    toggle.classList.add('is-expanded');
    panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
});
